// src/pages/AddArtifact.jsx
import React, { useState } from "react";
import api from "../api";
import { Box, Paper, TextField, Button, Typography, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function AddArtifact() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [transcript, setTranscript] = useState("");   // ⭐ Transcript
  const [image, setImage] = useState(null);
  const [audio, setAudio] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!title || !description || !image || !audio) {
      setError("Please fill all fields and select both image and audio files.");
      return;
    }

    try {
      setLoading(true);

      const fd = new FormData();
      fd.append("title", title);
      fd.append("description", description);
      fd.append("transcript", transcript);
      fd.append("image", image);
      fd.append("audio", audio);

      await api.post(`/api/artifacts`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setSuccess("Artifact added successfully.");
      setTimeout(() => navigate("/admin/artifacts"), 1200);
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.data?.message ||
        "Upload failed. Please check server / Wi-Fi connection."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Add Artifact
      </Typography>

      <Paper sx={{ p: 2 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <form onSubmit={submit}>
          <TextField
            label="Title"
            fullWidth
            required
            sx={{ mb: 2 }}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <TextField
            label="Description"
            fullWidth
            multiline
            rows={4}
            required
            sx={{ mb: 2 }}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          {/* ⭐ Transcript */}
          <TextField
            label="Transcript"
            fullWidth
            multiline
            rows={6}
            sx={{ mb: 2 }}
            value={transcript}
            onChange={(e) => setTranscript(e.target.value)}
            placeholder="Type narration script shown to visitors…"
          />

          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2">Select Image</Typography>
            <input
              accept="image/*"
              type="file"
              onChange={(e) => setImage(e.target.files[0])}
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2">Select Audio</Typography>
            <input
              accept="audio/*"
              type="file"
              onChange={(e) => setAudio(e.target.files[0])}
            />
          </Box>

          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? "Uploading..." : "Submit"}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}
